export default {
	contactHistory: 'Kontaktní historie',
	communicationOverviewHeader: 'Přehled komunikace s klienty',
	cancelRequestFilter: 'Žádost o storno',
	servicesFilter: 'Servisní služby',
	businessServicesFilter: 'Obchodní služby',
	date: 'Datum',
	client: 'Klient',
	contactType: 'Forma kontaktu s klientem',
	worker: 'Pracovník',
	distributionChannel: 'Distribuční kanál',
	businessService: 'Obchodní služba',
	blocking: 'Blokace',
	cancelRequest: 'Žádost o storno',
	services: 'Servisní služba',
	communicationInfoHeader: 'Detailní informace komunikace',
	creationDateFrom: 'Datum od',
	creationDateTo: 'Datum do',
	creationTimeFrom: 'Čas od',
	creationTimeTo: 'Čas do',
	servicesListHeader: 'Seznam poskytnutých služeb',
	service: 'Služba',
	psNumber: 'Číslo PS',
	product: 'Produkt',
	serviceType: 'Typ služeb',
	cancellationReason: 'Důvod storna',
	result: 'Výsledek',
	noteHeader: 'Poznámka',
	contactHistoryTableRecords1YearOldOnly: 'Je možné vyhledat pouze záznamy, které nejsou starší než 1 rok.',
	reportKH: 'Report KH',
	policyNo: 'Číslo PS',
	dateFrom: 'Datum komunikace od',
	dateTo: 'Datum komunikace do',
};
